/*
 * @Author: wuhao
 * @Date: 2020-04-08 14:28:17
 * @LastEditors: wuhao
 * @LastEditTime: 2021-01-15 10:59:40
 * @Description: 封装table搜索条件
 */

import ApexButton from './src/index'

ApexButton.install = function(Vue) {
  Vue.component(ApexButton.name, ApexButton)
}

export default ApexButton
